import instance from '../../api'

export const getFaqs = (search) => instance.get(`/api/admin/faqs${search ? `?${search}` : ''}`)

export const createFaq = (fields) => instance.post('/api/admin/faqs', fields)

export const updateFaq = (fields, id) => instance.put(`/api/admin/faqs/${id}`, fields)

export const deleteFaq = (id) => instance.delete(`/api/admin/faqs/${id}`)
